import { render, staticRenderFns } from "./index.vue?vue&type=template&id=29c6aa52&"
import script from "./index.ts?vue&type=script&lang=js&"
export * from "./index.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports